<template>
  <i :class="['icon-node-website', 'icon-' + name]" @click="$emit('click')"
    ><slot
  /></i>
</template>

<script>
export default {
  props: {
    name: {
      type: String
    }
  }
}
</script>
